import { Stack, styled } from '@mui/material'

export const MainWrap = styled(Stack)`
  flex: 1;
  padding: 64px 0 24px;

  ${(props) => props.theme.breakpoints.down('md')} {
    padding: 64px 0;
  }
`
